import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db, storage } from "../firebase";
import { addDoc, collection } from "firebase/firestore";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { Snackbar } from "@mui/material";
import { Alert } from "@mui/material";

const postCollectionRef = collection(db, "posts");
const photoCollectionRef = collection(db, "photos");

const AddPost = () => {
  const [body, setBody] = useState("");
  const [user, setUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!body.trim()) {
      setErrorMessage("Post cannot be empty!");
      setShowToast(true);
      return;
    }

    if (user) {
      const createdAt = new Date();
      const postData = {
        body: body,
        authorName: user.displayName,
        createdAt: createdAt.toISOString(),
      };

      if (photo) {
        // Firebase Storage'e fotoğrafı yükle
        const photoRef = await addDoc(photoCollectionRef, {
          photo: photo.name,
        });
        const storagePhotoRef = storageRef(
          storage,
          `photos/${photoRef.id}/${photo.name}`
        );
        await uploadBytes(storagePhotoRef, photo);

        // Firestore'a fotoğrafın URL'ini ekleyin
        const photoUrl = await getDownloadURL(storagePhotoRef);
        postData.photoUrl = photoUrl;
      }

      await addDoc(postCollectionRef, postData);

      setBody("");
      setPhoto(null);
      setErrorMessage("");
      setShowToast(true);
    } else {
      console.log("Kullanıcı oturum açmamış!");
    }
  };

  return (
    <div className="mt-8">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <textarea
          placeholder="What's on your mind?"
          className=" p-4 rounded-md bg-gray-200 w-80"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          rows={4}
        />
        <label className="flex items-center gap-2">
          <span className="bg-blue-500 text-white rounded-md px-3 py-2 cursor-pointer">
            Add Photo
          </span>
          <input
            type="file"
            name="myImage"
            accept="image/png, image/gif, image/jpeg"
            onChange={(e) => setPhoto(e.target.files[0])}
            className="hidden"
          />
          {photo && <span className="text-sm text-gray-100">{photo.name}</span>}
        </label>
        <button
          type="submit"
          className="w-full p-4 rounded-md bg-blue-500 text-white font-semibold hover:bg-blue-600 transition-colors duration-300"
        >
          Share Your Thoughts
        </button>
      </form>
      <Snackbar
        open={showToast}
        autoHideDuration={3000}
        onClose={() => setShowToast(false)}
      >
        {errorMessage ? (
          <Alert severity="error">{errorMessage}</Alert>
        ) : (
          <Alert severity="success">Post shared successfully!</Alert>
        )}
      </Snackbar>
    </div>
  );
};

export default AddPost;
